<template>
  <div class="mb-1 table-parent">
    <div class="table-responsive-xl table-wrapper">
      <table class="table table-striped">
        <thead class="contact-list-header bg-dark text-white">
          <tr class="table-row text-nowrap table-header">
            <th class="d-none d-sm-table-cell">
              <!--{{ $t('contacts.portrait') }}-->
            </th>
            <th @click="sortBy('name')" class="sortable">
              {{ $t('contacts.name') }}
              <span class="arrow" :class="sortOrders.name > 0 ? 'asc' : 'dsc'">
              </span>
            </th>
            <th @click="sortBy('email')" class="sortable">
              {{ $t('contacts.email') }}
              <span class="arrow" :class="sortOrders.email > 0 ? 'asc' : 'dsc'">
              </span>
            </th>
            <th
               v-if="0"
              @click="sortBy('status')"
              class="sortable d-none d-sm-table-cell"
            >
              {{ $t('contacts.status') }}
              <span
                class="arrow"
                :class="sortOrders.status > 0 ? 'asc' : 'dsc'"
              >
              </span>
            </th>
            <th>
              {{ $t('contacts.actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <contact-list-item
            v-for="contact in filteredContacts"
            :key="contact.id"
            :contact="contact"
            @update="onUpdate"
          />
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import ContactListItem from '@/components/Contacts/ContactListItem';


export default {
  name: 'ContactsList',
  props: ['contacts', 'searchText'],

  components: {
    ContactListItem,

  },

  data() {
    let sortOrders = {};
    sortOrders.name = 1;
    sortOrders.email = 1;
    sortOrders.polls_count = 1;
    sortOrders.status = 1;
    return {
      sortKey: '',
      sortOrders: sortOrders,

      searchKeys: ['name', 'email', 'status', 'polls_count'],
    };
  },
  computed: {
    filteredContacts: function () {
      let sortKey = this.sortKey || 'name';
      let filterKey = this.searchText && this.searchText.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let contacts = this.contacts;
      let searchKeys = this.searchKeys;
      if (filterKey) {
        contacts = contacts.filter(function (contact) {
          return Object.keys(contact).some(function (key) {
            return (
              searchKeys.includes(key) &&
              String(contact[key]).toLowerCase().indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        contacts = contacts.slice().sort(function (a, b) {
          a = a[sortKey].toLowerCase();
          b = b[sortKey].toLowerCase();
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return contacts;
    },
  },

  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },

    onUpdate(change) {
      this.$emit('update', change);
    }


  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.table {
  margin-bottom: 0px;
}

.contact-list-header {
  th {
    font-weight: 400;
    background-color: #191919 !important;
    font-size: 14px;
    padding: 0.25rem 0.75rem;
  }
}
.contact-list-header {
  font-size: 14px;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid white;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid white;
}

.sortable {
  cursor: pointer;
}

.table-parent {
  width: 100%;
}
</style>
